<template>
  <div class="betType-RR" :class="{inRefferalStakeChanged: inRefferalStakeChanged && currentBetSlipState==6}" >
    <template>
      <div class="header-RR rr_title">
        <span class="rr_first" key="rr_first">{{ $t('BetSlip.betType.RR.' + bt.IDFOBetType) }}</span>
        <span class="xWagers">
          x{{allowedBetTypesAndReturns.PotentialReturns.PerBetType[bt.IDFOBetType].UnitCount }} {{ $t('BetSlip.tab.RR.betType.wagers')}}
        </span>
      </div>
      <div class="bet_content">
        <div class="odds_div">
          <span class="price_title">{{ $t('BetSlip.oddsprice') }}</span>
          <span class="price">
            {{formatOdds(allowedBetTypesAndReturns.PotentialReturns.PerBetType[bt.IDFOBetType])}}
          </span>
        </div>
        <div class="stake-n-return">
          <stake-and-return
            :id="bt.IDFOBetType"
            :perType="'PerBetType'"
            :inRefferalStakeChanged="inRefferalStakeChanged && currentBetSlipState==6"
            :stakeChange="stakeChange"
          ></stake-and-return>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import store from '@/store'
  import priceFormat from '@/library/priceFormat'
  import stakeAndReturn from './stakeNreturn.vue'

  export default {

    name: 'StraightsTab',

    mixins: [
    ],

    props: ['bt', 'stake', 'parlayTeamsNo', 'allowedBetTypesAndReturns', 'gettingABTnR', 'currentBetSlipState'],

    data () {
      return {
        inRefferalStakeChanged: false,
        stakeChange: {old: 0, new: 0}
      }
    },

    components: {
      stakeAndReturn
    },

    computed: {
      inRefferal () {
        return store.getters['sbBetslipState/inRefferal']
      }
    },

    methods: {
      formatOdds (betType) {
        var odds = betType.PotentialReturn - betType.UnitCount + 1
        var formatted = priceFormat.formatOdds(odds, -1)
        return formatted
      }
    },

    mounted: function () {
    },

    watch: {
      stake (newVal, oldVal) {
//        console.log('RR Stake changed: ' + oldVal + ' -> ' + newVal)
        this.stakeChange = {old: oldVal || 0, new: newVal}
        this.inRefferalStakeChanged = this.inRefferal
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .header-RR {
    font-weight: bold;
    padding: 10px 12px 0;
    font-size: 14px
  }

  .stake-n-return
    padding: 5px 6px 5px
    border-radius: 0 0 5px 5px;

  .odds
    color: #0F89F1

  .inRefferalStakeChanged
    border-style: solid
    border-color: #EA913C
    border-width: 1px !important
    /*background-color: #FFF2E5*/
    /*margin-top: -1px !important*/
    border-radius: inherit;

</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/betTypeRR.vue